export default __webpack_public_path__ + "static/media/ex012-3513-00.c7b24eab.jpg";